(function () {
  'use strict';

  angular.module('sempraWebapp').factory('InvoiceStatusEnum', invoiceStatusEnumFactory);

  /** @ngInject */
  function invoiceStatusEnumFactory () {
    return Object.freeze({
      NEW : 'NEW',
      PENDING: 'PENDING',
      CANCELED : 'CANCELED'
    });

  }
})();
